// ScionOnField.js
// GROWTH REGULATOR TREATMENT RECORD

import React from "react";
import { useState, useEffect, useContext } from "react";
import { getDBURL } from "../Utils/Utils";
import { useFetch } from "use-http";
import { useNavigate } from "react-router-dom";
import { Box, Button, Text, Image, ResponsiveContext } from "grommet";
import ConfirmPopupWindow from "./ConfirmPopupWindow";
import DangerPopupWindow from "../Base components/DangerPopupWindow";
import ProgressBar from "../Base components/ProgressBar";
import { updateStateHandler, sheetStatus, getKeyByValue } from "../Utils/Utils";
import StationPopup from "./StationPopup";
import { Trophy, SubtractCircle, RadialSelected, CircleInformation, FastForward} from "grommet-icons";
import EvaluationSummary from "../Base components/EvaluationSummary";
import SheetStateButton from "../Base components/SheetStateButton";
import OpenSummaryButton from "../Base components/OpenSummaryButton";
import { now } from "underscore";
import { UserContext } from "../../App";

const sheetChoices = {
    treatment: 1,
    ted: 2
}

const ScionOnField = (props) => {
    const {plant, seedlingId, seedlingYear} = props;
    const currentUser = useContext(UserContext);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false); // show/hide 'Confirm' popup
    const [dangerPopupOpen, setDangerPopupOpen] = useState(false); //show/hide Danger Popup Window

    const [editable, setEditable] = useState(false); //when the "edit" button is clicked, convert the submitted ted into editable mode.
    const [openStationPopup, setOpenStationPopup] = useState(false);
    const [scionTreatments, setScionTreatments] = useState([]); // all treatments for the scion
    const [selectedTreatment, setSelectedTreatment] = useState(null); // sets selected one in set of loaded treatments

    // const [sourceSeedlingId, setSourceSeedlingId] = useState(0);
    // const [sourceSeedlingInfo, setSourceSeedlingInfo] = useState([]);
    const [sheetChoice, setSheetChoice] = useState(0); // which of buttons was pressed ted or treatment

    const [newStationNum, setNewStationNum] = useState(0);
    // console.log('In ScionOnField plant >> ', plant); 

    const [showEvaluationSummary, setShowEvaluationSummary] = useState(false);
    const [evaluationMaxGrade, setEvaluationMaxGrade] = useState(0);

    const initSheetsColorState = () => {
        // console.log(' << initSheetsColorState >> '); 
        return [
            {
                sheetNum: 0,
                sheetID: null,
                sheetStatus: null,
                createDate: null,  
                finishDate: null,         
                sheetColor: "status-unknown",
                sheetName: "",
                gradeColor: "status-unknown",
                grade: 0,
            },
        ];
    }    

    const [sheetColor, setSheetColor] = useState(initSheetsColorState());

    const { get, post } = useFetch(
        getDBURL()
    );  


    // // f-n gets number of station of the scion , returns id of seedling from it was created the station
    // async function getSeedlingForStation(stationID) { 
    //     const sourceSeedling = await get("/getSeedlingByStationId/station_id=" + stationID) 
    //      if (sourceSeedling !== null){
    //         // console.log("sourceSeedling:  "+ sourceSeedling);
    //         setSourceSeedlingId(sourceSeedling);
    //         return sourceSeedling;
    //     }
    // }    

    // size of screen: small - mobile, medium - ipad, large - computer
    const size = useContext(ResponsiveContext);

    useEffect(() => {
        // console.log(' << useEffect first re-rendering >> '); 
        // get all treatments for scion
        (async function loadTreatmentsByScionId() {
            try {
                // console.log("plant:  ", plant);
                // console.log("ScionId:  "+ plant.Id);
                const res = await get("/loadTreatmentsByScionId/scion_id=" + plant.Id + "/dt=" + Date.now())
                // console.log("treatments list: ", res);
                if( res !== undefined && res.length > 0) {
                    setScionTreatments(res); 
                    setEvaluationMaxGrade(res[0].MaxGrade); 
                }                           
            }
            catch (error) {
                console.log('In loadTreatmentsByScionId: ', error.message);
            }        
        })();
    }, [])

    useEffect(() => {
        // console.log(' << useEffect on scionTreatments change >> '); 
        if (scionTreatments.length > 0)
        {
            // console.log("scionTreatments list:", scionTreatments);
            let temp = [];
            scionTreatments.map((sheetData) => {                      
                temp.push ({
                    sheetNum: sheetData.SheetNum,
                    sheetID: sheetData.SheetId,
                    sheetStatus: sheetData.SheetStatus,
                    createDate: sheetData.CreateDate, 
                    finishDate: sheetData.FinishDate,                      
                    sheetColor:
                        sheetData.SheetStatus === getKeyByValue(sheetStatus,'Submitted') 
                            ? "#6FFFB0"    // "accent-1"
                            : sheetData.SheetStatus === getKeyByValue(sheetStatus,'In Progress') 
                                ? "#f6fc56"    // "accent-4"
                                : "#CCCCCC",    // "status-unknown", 
                    sheetName:
                        sheetData.SheetName !== null ? sheetData.SheetName : "no treatment",                                                                     
                    gradeColor: 
                        sheetData.EvalGrade === 0
                        ? "#CCCCCC"    // "status-unknown"
                        : (sheetData.EvalGrade > 0 && sheetData.EvalGrade < 35) 
                            ? "#ffc3a1" 
                            :  (sheetData.EvalGrade >= 35 && sheetData.EvalGrade < 80) 
                                ? "lightyellow" : "lightgreen",
                    evaluationGrade: sheetData.EvalGrade,
                    evaluationProgress: sheetData.EvalProgress                                                     
                })              

            });
            setSheetColor(temp);
        }
    }, [scionTreatments]);



    useEffect(() => {
        // console.log(' << useEffect on the new station creating >> '); 
        // runs after the new station was created from the scion
        if(newStationNum !== 0) {
            // console.log("new Station Num:", newStationNum);            
            (async function updatePlantStatus() {
                try {
                    await post(`/updateScionStatus/id=${plant.Id}/status=1/statuseditedby=${currentUser.email}`);                    
                    updateStateHandler(props.setPlantInfo,'StatusID',1);
                    props.onCreateNewStation(newStationNum);
                    props.setShow(false);                      
                }
                catch (error) {
                    console.log('In updatePlantStatus: ', error.message);
                }
            })();
        }             
    }, [newStationNum])

    useEffect(() => {
        // console.log(' << useEffect on the selectedTreatment changing or sheetChoice changing >> '); 
        if (selectedTreatment !== null &&  sheetChoice !== 0)
            openSheet();
    }, [selectedTreatment, sheetChoice])
  
    // hides the "Confirm" popup window
    const onClose = () => {
      setOpen(false);
    };

    const openTreatment = (treatment) => {
        setSheetChoice(sheetChoices.treatment);
        setSelectedTreatment(treatment);
    };

    const openEvaluation = (evaluation) => {
        setSheetChoice(sheetChoices.ted);
        setSelectedTreatment(evaluation);
    };

    const onOpenStationPopup = () => {
         setOpenStationPopup(true);
    };

    const onCloseStationPopup = () => { 
        setOpenStationPopup(false);
        setOpen(false);    
        props.reRender();
    };

    // opens a popup window when the "disqualify" button is clicked
    const openDangerPopupWindow = () => {
        setDangerPopupOpen(true);
    }

    // hides the "Danger" popup window 
    const onDangerPopupClose = () => {
        setDangerPopupOpen(false);    
    };

    // fires when the "Yes" button is clicked in the "Danger" popup
    const onDangerConfirm = async () => {
        // console.log(' << in function onDangerConfirm >> '); 
        await disqualify();
        onDangerPopupClose();
    }; 

    const disqualify = async () => {
        try {
            await post(`/updateScionStatus/id=${plant.Id}/status=3/statuseditedby=${currentUser.email}`);
            updateStateHandler(props.setPlantInfo, 'StatusID', 3);
            props.reRender();
        } catch (error) {
            console.log('Error in disqualify:', error.message);
        }
        props.setShow(false);
    };

      

    // opens a popup window when the "edit" button is clicked
    const openConfirmWindow = () => {
        // console.log(' << in function openConfirmWindow >> '); 
        setOpen(true);
    }

    // fires when the "Confirm" button is clicked in the "Confirm" popup
    const onConfirm = () => {
        // console.log(' << in function onConfirm >> '); 
        setSheetChoice(sheetChoices.ted);
        setEditable(true);
        onClose();
    };

    // console.log('ScionOnField props.selectedField >> ',  props.selectedField);        
    // console.log('ScionOnField props.selectedStationNum >> ', props.selectedStationNum);        
    // console.log('ScionOnField props.activeStationsList >> ', props.activeStationsList);        
    // console.log('evaluationMaxGrade >> ', evaluationMaxGrade);
    // console.log('sheetColor >> ', sheetColor);


    const openSheet = () => {
        // console.log(' << in function openSheet >> '); 
        let disable = false; 

        // console.log('sheetChoice >> ', sheetChoice);
        // console.log('selectedTreatment >> ', selectedTreatment);
        // console.log('editable >> ', editable);
        // console.log('plant >> ', plant);        
        if (sheetChoice === sheetChoices.treatment || (sheetChoice === sheetChoices.ted && (selectedTreatment.sheetStatus === 3 || selectedTreatment.sheetStatus === 5)) ) 
            disable = true; 

        disable = (editable === true ? false : disable); 
        // console.log('In ScionOnField disable >> ', disable);

        if (sheetChoice === sheetChoices.treatment) {
            if (selectedTreatment.sheetID === null)
            {
                alert("No treatment");
            }
            else {
                navigate("/treatment", {
                    state: {
                        selectedField: props.selectedField,
                        station: props.selectedStation,
                        activeStationsList: props.activeStationsList,                          
                        rootstockList: props.rootstockList,  
                        plantInfo: plant,  
                        scionsList: null,                                  
                        editMode: true,
                        disable: disable,
                        sheetName: "TREATMENT",
                        treatmentID: selectedTreatment.sheetID,
                    },                  
                });
            }
        }
        else if(sheetChoice === sheetChoices.ted){ //TED
            if (selectedTreatment.sheetID === null){ // new TED
                navigate("/preharvest", {
                    state: {
                        selectedField: props.selectedField,
                        station: props.selectedStation,                        
                        plantInfo: plant,
                        seedlingId: seedlingId,
                        seedlingYear: seedlingYear,
                        activeStationsList: props.activeStationsList,
                        editMode: false,
                        editYear: true,
                        disable: disable,
                        sheetName: "TREATMENT EVALUATION DATA",                         
                    },
                })
            }
            else { 
                navigate("/preharvest", { // already existing TED
                    state: {
                        selectedField: props.selectedField,
                        station: props.selectedStation,                        
                        plantInfo: plant,
                        seedlingId: seedlingId,
                        seedlingYear: seedlingYear,                        
                        activeStationsList: props.activeStationsList,                        
                        editMode: true,
                        editYear: false,                        
                        disable: disable,
                        sheetName: "TREATMENT EVALUATION DATA",
                        preharvestID: selectedTreatment.sheetID, 
                    },
                })
            }
        }        
    }





    const drawTreatment = (el) => {
        return (
            <Box key={Math.random(now())}>
            { (el === undefined)
                ?
                <Box align="center"
                    //direction="row-responsive"
                    //margin="xxsmall"
                    >
                    <Box pad="xxsmall" width = "340px" margin="xxsmall">
                        <Button     
                            color="status-unknown"
                            style={{padding: "0px"}}
                            primary                            
                            label="no treatment"
                            onClick={() => {}}
                        />
                        </Box>                            
                </Box>
                :
                <Box align="center"
                    key={('t_' + el.sheetID + "_" + el.sheetNum + "_" + el.createDate)}
                    >
                    <Box pad="xxsmall" 
                    width = "340px"
                    margin="xxsmall" 
                    >
                        <SheetStateButton evaluationMaxGrade={evaluationMaxGrade} el={el} 
                        openSheet={openTreatment} />                             
                    </Box>                          
                </Box> 

            }
            </Box>
        );
    }


    const drawEvaluation = (el) => {
        
        return (
            <Box key={'e_' + Math.random(Date.now)}>
            {(el.sheetNum === 0) ? (<></>)
            :
            <Box align="center"
                direction="row-responsive"
                key={('e_' + el.sheetID + '_' + el.sheetNum + '_' + el.createDate)}
                >
                <Box direction="row" width="190px">
                    <Box margin="auto" align="center" >
                        <FastForward  color="brand" size='15px' />                                
                    </Box>         
                    <Box pad="xxsmall" width= "150px" >
                        <SheetStateButton evaluationMaxGrade={evaluationMaxGrade} el={el} openSheet={openEvaluation} />                             
                    </Box>                            
                </Box>

                <Box  direction="row"  align="center" > 
                    <OpenSummaryButton evaluationMaxGrade={evaluationMaxGrade} el={el} 
                                showEvaluationSummary = {setShowEvaluationSummary} 
                                setSelectedEvaluation = {setSelectedTreatment} />                        
                
                    {/* evaluation finished */}
                    {(el.sheetStatus === 3  || el.sheetStatus === 5 ) && (
                        <> 
                        <Box pad={{horizontal: "xxsmall"}} width= "110px">
                            {/* <Box  margin="xxsmall"> */}
                                <Button                           
                                    color="#f0869c"
                                    style={{color: "#ffffff", padding: 0, fontSize: "16px"}}
                                    primary
                                    // label={plant.Id}
                                    label="edit"
                                    onClick={() => openConfirmWindow(el)}
                                />
                            {/* </Box>   */}
                        </Box>                                
                        </>
                    )}

                    {/* evaluation not finished  display evaluation progress*/}
                    {(el.sheetStatus === 4 ) && (
                    <Box pad="xxsmall"  width= "110px" >
                        <Box margin="xxsmall" align="center" round={true} 
                            background={
                                `radial-gradient(circle farthest-corner at 0% 50%, #6FFFB0 ${el.evaluationProgress === 100 ? el.evaluationProgress : el.evaluationProgress-10}%, #f8facd ${el.evaluationProgress}%, #f6fc56 100%)`
                            }>
                            <Text 
                                fill="horizontal"
                                weight="bold" > {el.evaluationProgress} %
                            </Text>
                        </Box>
                    </Box>                                
                    )}                                
                </Box> 
            </Box>


            }
            </Box>
            );

        }
    

    const drawSheetButtons = (sheetColor) => {
        let lastPrinted = initSheetsColorState()[0]; // Initialize lastPrinted with the empty element

        // if the current element, we need to print, is the evaluation button and toPrint = 0, 
        // then we need to print an empty Treatment button before the evaluation button
        let toPrint = 0;    

        const updateLastPrinted = (el) => {
          lastPrinted = el; // Update lastPrinted with the current element
        };

      
        return (
          <>
            {/* {console.log('sheetColor in drawSheetButtons  ', sheetColor)} */}
            {sheetColor.length > 0 &&
              sheetColor.map((el, index) => {
                if (index === 0 && el.sheetNum === 2) {

                    return (
                        <Box key={Math.random(Date.now())}>
                            {drawTreatment()}
                            {drawEvaluation(el)}
                        </Box>                 
                    )
                } else if (el.sheetNum === 1) {
                    updateLastPrinted(el); // Update lastPrinted with the current element
                    toPrint = 0;
                    return drawTreatment(el);
                } else {
                    if (lastPrinted.finishDate < el.createDate && toPrint === 0){
                        toPrint++;
                        return (
                            <Box key={Math.random(Date.now())}>
                                {drawTreatment()}
                                {drawEvaluation(el)}
                            </Box> )                
                    } else
                        return drawEvaluation(el);
                }
              })}
          </>
        );
      };
         

    let bg = "#bed3be";
    if (plant.StatusID === 3 || plant.IsSeeded === 1)
        bg = "#ffc3a1";

    const style = {
        border: "2px solid",
        margin: "10px",
    };
    
    return (
        <Box  style={style} direction="row" align="start"  background={bg}>
            {open && (
            <ConfirmPopupWindow
                msg={
                    "You have chosen to edit a submitted sheet. This might affect the processing flow. Are you sure you want to proceed?"
                }
                onClose={onClose}
                onConfirm={onConfirm}
            />
            )} 
            {dangerPopupOpen && (
            <DangerPopupWindow
                msg={
                    "The scion will be disqualified! Are you sure you want to continue?"
                }
                onClose={onDangerPopupClose}
                onConfirm={onDangerConfirm}
            />
            )}
            {/* left side  */}
            <Box  > 
                <Box width="140px">
                    <Image
                        size="contain"
                        src="ScionIcon.PNG" 
                        width="100px"                                    
                        height="100px"                                
                    />             
                </Box>
                {(plant.StatusID === 1 ) && (
                <Box  align="center" height="100px" pad={{vertical: "medium"}}>
                    <Trophy  color="#047343" size='large' />                                
                </Box>
                )}
                <Box direction="row" align="center" justify="evenly" >
                    {(plant.StatusID === 3 ) && (
                    <Box  align="center" pad={{vertical: "medium"}} >
                        <SubtractCircle  color="status-critical" size='large' />                                
                    </Box>
                    )} 
                    {(plant.IsSeeded === 1 ) && (
                    <Box  align="center"  pad={{vertical: "medium"}} >
                        <RadialSelected  color="status-critical" size='44px' />                                
                    </Box>
                    )} 
                </Box>  
            </Box> 
             {/* end of the left side  */}
            <Box  
                background="light-3"
                width= "100%"
                height="100%"
                pad="xsmall" 
                >
                {/* data about scion */}
                <Box pad={{vertical: "small"}} align="center">
                    <Box pad={{horizontal: "xsmall"}} direction="row-responsive">
                        <Box direction="row" >
                            <Text margin={{horizontal: "xsmall"}} size="medium" > Station:</Text>
                            <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium" > {plant.StationNum} </Text>
                        </Box>
                        <Box direction="row"  >
                            <Text margin={{horizontal: "xsmall"}} size="medium" > Rootstock:</Text>
                            <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium" > {plant.RootstockName} </Text>
                        </Box>
                    </Box>            
                    <Box pad={{horizontal: "xsmall"}} direction="row-responsive">
                        <Box pad={{horizontal: "xsmall"}} direction="row">
                            <Box direction="row">
                                <Text margin={{horizontal: "xsmall"}} size="medium" > id:</Text>
                                <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium" > {plant.SID} </Text>
                            </Box>
                            <Box direction="row" >
                                <Text margin={{horizontal: "xsmall"}} size="medium"> year: </Text>  
                                <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium"> {plant.Year} </Text> 
                            </Box>
                        </Box>
                        <Box pad={{horizontal: "xsmall"}} direction="row">
                            <Box direction="row">
                                <Text margin={{horizontal: "xsmall"}} size="medium" > row:</Text>
                                <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium" > {plant.Row} </Text>
                            </Box>                    
                            <Box direction="row" >
                                <Text margin={{horizontal: "xsmall"}} size="medium"> vine:</Text>    
                                <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium"> {plant.Column} </Text> 
                            </Box>
                        </Box>
                    </Box>
                </Box>
                {/* end of data about scion */}

                <Box background="neutral-3" height="2px" margin={{vertical: "small"}}> </Box>

                <Box pad={{vertical: "small"}} align="center"  background="light-4"  direction="row-responsive" justify="around">
                    <Box pad={{horizontal: "xsmall"}} direction="column" >
                        <Box >
                            <Text weight="bold" margin={{vertical: "xsmall"}} size="medium" > Scion: </Text>
                        </Box>
                        <Box direction="row" pad={{vertical: "xxsmall"}} >
                            <Trophy  color="#047343" size='medium' />
                            <Text  margin={{horizontal: "xsmall"}} size="medium" > excellent </Text>
                        </Box>

                        <Box direction="row"  pad={{vertical: "xxsmall"}} >
                            <SubtractCircle  color="status-critical" size='medium' />
                            <Text  margin={{horizontal: "xsmall"}} size="medium" > disqualified </Text>
                        </Box> 

                        <Box direction="row"  pad={{vertical: "xxsmall"}} >
                            <RadialSelected  color="status-critical" size='medium' />
                            <Text  margin={{horizontal: "xsmall"}} size="medium" > seeded </Text>
                        </Box>                                                           
                    </Box>            

                    <Box pad={{horizontal: "xsmall"}} direction="column">
                        <Box >
                            <Text weight="bold" margin={{vertical: "xsmall"}} size="medium" > Grades: </Text>
                        </Box>

                        <Box direction="row"   align="center">
                            <Box pad="xxsmall" width= "30px" background="#ffc3a1" margin="xxsmall" align="center" round={true}>
                                <Text  size="small" 
                                    fill="horizontal"
                                    weight="bold" >{25}
                                </Text>                                                  
                            </Box>
                            <Text  margin={{horizontal: "xsmall"}} size="medium" > grade  &lt; 35 </Text>                         
                        </Box>                    

                        <Box direction="row" align="center" >
                            <Box pad="xxsmall" width= "30px" background="lightyellow" margin="xxsmall" align="center" round={true}>
                                <Text  size="small" 
                                    fill="horizontal"
                                    weight="bold" >{40}
                                </Text>
                            </Box>
                            <Text  margin={{horizontal: "xsmall"}} size="medium" > 35 &le; grade  &lt; 80 </Text>                         
                        </Box>   

                        <Box direction="row" align="center" >
                            <Box pad="xxsmall" width= "30px" background="lightgreen" margin="xxsmall" align="center" round={true}>
                                <Text  size="small" 
                                    fill="horizontal"
                                    weight="bold" >{70}
                                </Text>
                            </Box>                    
                            <Text  margin={{horizontal: "xsmall"}} size="medium" > grade  &ge; 80 </Text>                         
                        </Box>                  
                    </Box>                           
                </Box>

                <Box pad={{vertical: "small"}} align="center"  background="light-4"  direction="row-responsive" justify="around">
                    <Box pad={{horizontal: "xsmall"}} direction="column">
                        <Box >
                            <Text weight="bold" margin={{vertical: "xsmall"}} size="medium" > Treatment: </Text>
                        </Box>
                        <Box direction="row-responsive" pad={{vertical: "xxsmall"}} >
                            <Box direction="row" pad={{vertical: "xxsmall"}}  >                                             
                                <Box pad="xxsmall" width= "40px" background="#f8f000" margin="xxsmall" align="center" round={true}> </Box>
                                <Text margin={{horizontal: "xsmall"}} size="medium" > In Progress </Text>
                            </Box>                         
                                
                            <Box direction="row" pad={{vertical: "xxsmall"}}  >
                                <Box pad="xxsmall" width= "40px" background="#6FFFB0" margin="xxsmall" align="center" round={true}> </Box>
                                <Text margin={{horizontal: "xsmall"}} size="medium" > Finished </Text>
                            </Box>
                        </Box>
                    </Box>              
                </Box> 

                <Box background="neutral-3" height="2px" margin={{vertical: "small"}}> </Box>

                {/* list of buttons: TED and Treatment  with grade for each TED */}
                <Box align="center">
                    <Box pad={{vertical: "small"}} >
                        {sheetColor.length > 0 &&
                            drawSheetButtons(sheetColor)
                        }                     

                        {showEvaluationSummary &&
                        <Box>
                            <EvaluationSummary plant={plant} setPlantInfo={props.setPlantInfo} 
                                setShowEvaluationSummary={setShowEvaluationSummary}
                                evaluation={(selectedTreatment.sheetID)}
                            />
                        </Box>
                        }  

                        {openStationPopup && <StationPopup onClose={onCloseStationPopup} plantInfo={plant} createStation={setNewStationNum} ></StationPopup>}

                        {/* Do not display buttons if the scion is already excellent or disqualified */}
                        {(plant.StatusID !== 1) && (plant.StatusID !== 2) && (plant.StatusID !== 3) && (
                        <Box direction={size === "xxsmall" ? "row" : "row-responsive" } justify="around" 
                            margin="auto" >                
                            <Box pad="xxsmall" width= "150px" margin="5px" >
                            <Button    
                                                       
                                    color="status-unknown"
                                    style={{padding: '0px'}}
                                    primary
                                    label="new st Eval-n"
                                    onClick={() => {
                                        setSheetChoice(sheetChoices.ted);
                                        setSelectedTreatment(initSheetsColorState()[0]);                                     
                                    }}
                                />                            
                                {/* {props.stationList === undefined &&
                                <Button label="create station" onClick={onOpenStationPopup} />}    */}
                            </Box> 
                            <Box  pad="xxsmall"  width= "150px"  margin="5px" >
                                {(sheetColor.length > 0) && 
                                <Button 
                                   
                                    color="#ffc3a1" 
                                    primary
                                    label="disqualify" 
                                    style={{padding: 0}}
                                    onClick={() => openDangerPopupWindow()}
                                />}   
                            </Box>  
                        </Box> 
                        )}

                    </Box> 
                </Box> 
                {/* end of button list: TED and Treatment */}
              
                <Box
                  //  pad="xsmall"
                    pad={{vertical: "xsmall"}}
                    margin="auto"
                    align="center"
                    justify="around"
                    direction="row"
                    >
                        <Button label="close" 
                        style={{color: "#ffffff", padding: "0px", width: "150px"}}
                        primary onClick={() => props.setShow(false)} />   
                </Box>              
            </Box>               
        </Box>
    );
};

export default ScionOnField;
